<template>
  <div class="pt-4">
    <ProfileRolesTable />
  </div>
</template>

<script lang="ts" setup>
import ProfileRolesTable from '@/components/deepadmin/profile/ProfileRolesTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_account.roles',
  },
})
</script>
